import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface PlayIconProps extends IconWrapperProps {
  color?: string;
  width?: string;
}

const PlayIcon = ({ color = "currentColor", width, ...rest }: PlayIconProps) => (
  <IconWrapper width={width || '32px'}  viewBox="0 0 32 32" {...rest}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillOpacity="0"
        d="M7 7H17V17H7z"
        transform="translate(-24 -778) translate(0 104) translate(24 674)"
      />
      <path
        fill={color}
        d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1.837 5.102l7.244 4.41c.416.25.416.775 0 1.025l-7.244 4.361c-.403.238-.882.038-.882-.375V7.477c0-.413.479-.613.882-.375z"
        transform="translate(-24 -778) translate(0 104) translate(24 674)"
      />
    </g>
  </IconWrapper>
);

export default memo(PlayIcon);
